import { z } from "zod";
import { LaboratorySchema } from "./laboratory.entities";

export enum UserSchemaEnum {
	User = "User"
};

// this interface is used to define the structure of the user entity from audiowizard back-en
export const UserSchema = z.object({
	"@id": z.string(),
	"@type": z.string(),
	id: z.number().optional(),
	email: z.string().optional(),
	roles: z.array(z.string()).optional(),
	password: z.string().optional(),
	firstName: z.string().optional(),
	lastName: z.string().optional(),
	gender: z.string().optional(),
	company: z.object({
		"@id": z.string(),
		id: z.number(),
		label: z.string(),
		hiboutikAccount: z.object({
			subDomain: z.string(),
			token: z.string(),
		}),
	}),
	laboratories: z.array(LaboratorySchema),
	createdAt: z.string().optional(),
	updatedAt: z.string().optional(),
	deletedAt: z.string().optional(),
	fullName: z.string().optional(),
}).describe(UserSchemaEnum.User);

export type User = z.infer<typeof UserSchema>;
